import { SchemaToQuickAccessItem, QuickAccess, attemptGetConfigFromQuery, getRemoteQuickAccessConfig } from './index'

import {Workbox} from 'workbox-window';
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API/Using_Service_Workers
 * @see https://developer.chrome.com/docs/workbox/modules/workbox-window/
 */
async function setupServiceWorker () {
    if ('serviceWorker' in navigator) {
        const wb = new Workbox('./sw.js');
        wb.register();
    }
}

(async function () {
    // setTimeout(() => setupServiceWorker, 1)
    const config = await attemptGetConfigFromQuery()
    if (!config) {
        // throw new Error('Config required')
        console.debug('No config obtainable for quick-access, so ignoring.')
        const processGuide = await (await fetch('./process-guide.html')).text()
        const wrapper = document.querySelector('#wrapper')
        if (wrapper) {
            wrapper.innerHTML = processGuide
        }
        return
    }

    const { items, options } = config
    const quickAccess = new QuickAccess(items.filter(item => {
        return !item.disabled
    }).map(item => {
        if (item.alternateName && item.alternateType) {
            return SchemaToQuickAccessItem(item)
        } else {
            return item
        }
    }), options)
    await quickAccess.loadDependencies()
    quickAccess.setup()
})()
